import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import PageTitle from 'components/PageTitle';
import CarItem from 'components/CarItem';
import SearchCount from 'components/SearchCount';

import '../Search/styles.scss';
import containerActions from './actions';

class ApprovedPage extends React.Component {
  state = {
    cars: []
  }
  componentWillMount() {
    this.props.getApproved((cars) => {
      const { user } = this.props;
      const carsArrayEquallyTypeOfCar = cars.filter(car =>
        car.typeOfCar.toUpperCase() === user.typeOfCar.toUpperCase());
      const carsArrayNotEquallyTypeOfCar = cars.filter(car =>
        car.typeOfCar.toUpperCase() !== user.typeOfCar.toUpperCase());
      let sortCarsArray = [];
      sortCarsArray = sortCarsArray.concat(carsArrayEquallyTypeOfCar);
      sortCarsArray = sortCarsArray.concat(carsArrayNotEquallyTypeOfCar);

      this.timer = setInterval(() => {
        if (this.state.cars.length !== sortCarsArray.length) {
          this.setState(prevState => ({
            cars: [...prevState.cars, sortCarsArray[this.state.cars.length]]
          }));
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 300);
    });
  }


  timer = null;
  goBack = () => {
    this.props.history.goBack();
  }
  render() {
    const { cars } = this.state;

    return (
      <div className="page-search -not-full -approved">
        {/* <button className="search-button">
          <i className="material-icons">close</i>
        </button> */}
        <button className="close-button" onClick={this.goBack} >
          <i className="material-icons">close</i>
        </button>
        <PageTitle>
			You have been <br /> conditionally <span>approved</span> <br /> for a car
        </PageTitle>
        <SearchCount count={this.props.cars.length} />
        <TransitionGroup className="search-list">
          {
            cars.map(car => (
              <CSSTransition
                key={car.id}
                classNames="car"
                timeout={500}
              >
                <CarItem
                  name={car.name}
                  image={car.image}
                  isLink
                  to={car.id}
                  perMounth={car.perMounth}
                />
              </CSSTransition>
            ))
          }
        </TransitionGroup>
      </div>
    );
  }
}

ApprovedPage.defaultProps = {
  cars: []
};

ApprovedPage.propTypes = {
  // eslint-disable-next-line
  cars: PropTypes.array,
  // eslint-disable-next-line
  user: PropTypes.object.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object,
  getApproved: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  cars: state.approved.cars,
  user: state.user.user
});


export default connect(mapStateToProps, containerActions)(ApprovedPage);



// WEBPACK FOOTER //
// ./src/pages/Approved/index.js